import { useDiscrepancyManagement } from "@/hooks/useDiscrepancyManagement";
import { JustificationDialog } from "./discrepancy/JustificationDialog";
import { DiscrepancyCardContent } from "./discrepancy/DiscrepancyCardContent";

export const DiscrepancyManager = () => {
  const {
    discrepancies,
    selectedDiscrepancy,
    setSelectedDiscrepancy,
    isDialogOpen,
    setIsDialogOpen,
    selectedAmount,
    setSelectedAmount,
    isExpanded,
    setIsExpanded,
    selectedPeriod,
    setSelectedPeriod,
    handleStatusUpdate
  } = useDiscrepancyManagement();

  const handleJustifiedClick = (discrepancy: any) => {
    setSelectedDiscrepancy(discrepancy);
    setIsDialogOpen(true);
  };

  const handleConfirmJustified = () => {
    if (selectedDiscrepancy) {
      handleStatusUpdate(selectedDiscrepancy.id, "justified");
    }
  };

  return (
    <>
      <DiscrepancyCardContent
        discrepancies={discrepancies || []}
        isExpanded={isExpanded}
        selectedPeriod={selectedPeriod}
        onPeriodChange={setSelectedPeriod}
        onToggleExpanded={() => setIsExpanded(!isExpanded)}
        onJustifiedClick={handleJustifiedClick}
        onStatusUpdate={handleStatusUpdate}
      />

      <JustificationDialog
        isOpen={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        selectedDiscrepancy={selectedDiscrepancy}
        selectedAmount={selectedAmount}
        onAmountChange={setSelectedAmount}
        onConfirm={handleConfirmJustified}
      />
    </>
  );
};